// dariWords.js

export const dariWords = [
  { dari: 'خانه', english: 'Home' },
  { dari: 'کتاب', english: 'Book' },
  { dari: 'مدرسه', english: 'School' },
  { dari: 'دوست', english: 'Friend' },
  { dari: 'سلام', english: 'Hello' },
  { dari: 'تشکر', english: 'Thank you' },
  { dari: 'بلی', english: 'Yes' },
  { dari: 'نی', english: 'No' },
  { dari: 'آب', english: 'Water' },
  { dari: 'نان', english: 'Bread' },
  { dari: 'چای', english: 'Tea' },
  { dari: 'مادر', english: 'Mother' },
  { dari: 'پدر', english: 'Father' },
  { dari: 'وطن', english: 'Homeland' },
  { dari: 'قریه', english: 'Village' },
  { dari: 'بازار', english: 'Bazaar' },
  { dari: 'مقبول', english: 'Beautiful' },
  { dari: 'بسیار', english: 'Very' },
  { dari: 'فامیل', english: 'Family' },
  { dari: 'آفتاب', english: 'Sun' },
  { dari: 'مهتاب', english: 'Moon' },
  { dari: 'ستاره', english: 'Star' },
  { dari: 'دل', english: 'Heart' },
  { dari: 'کوه', english: 'Mountain' },
  { dari: 'برف', english: 'Snow' },
  // Added to give the letter lessons an example for every letter.
  // No recordings yet — the 🔊 icon lights up automatically once each is recorded.
  { dari: 'ثروت', english: 'Wealth' },
  { dari: 'جنگل', english: 'Forest' },
  { dari: 'حیوان', english: 'Animal' },
  { dari: 'غذا', english: 'Food' },
  { dari: 'اژدها', english: 'Dragon' },   // ژ isolated
  { dari: 'مژه', english: 'Eyelash' },     // ژ final (م joins → ژ)
  { dari: 'صبح', english: 'Morning' },
  { dari: 'مریض', english: 'Sick' },
  { dari: 'ظهر', english: 'Noon' },
  { dari: 'عشق', english: 'Love' },
  { dari: 'باغ', english: 'Garden' },
  { dari: 'گل', english: 'Flower' },
  // --- Gap-fillers: each chosen so the target letter sits in a position the
  //     corpus was missing. Common Dari/Afghan vocabulary.
  { dari: 'شب', english: 'Night' },        // ش initial, ب final
  { dari: 'لباس', english: 'Clothes' },    // ل initial, س isolated
  { dari: 'گوش', english: 'Ear' },         // ش isolated
  { dari: 'بخش', english: 'Section' },     // خ medial, ش final
  { dari: 'سرخ', english: 'Red' },         // خ isolated
  { dari: 'تاریخ', english: 'History' },   // خ final
  { dari: 'توپ', english: 'Ball' },        // پ isolated
  { dari: 'سپاه', english: 'Army' },       // پ medial
  { dari: 'اسپ', english: 'Horse' },       // پ final
  { dari: 'ارث', english: 'Inheritance' }, // ث isolated
  { dari: 'مثال', english: 'Example' },    // ث medial
  { dari: 'بحث', english: 'Discussion' },  // ث final, ح medial
  { dari: 'روح', english: 'Soul' },        // ح isolated
  { dari: 'برج', english: 'Tower' },       // ج isolated
  { dari: 'نجات', english: 'Rescue' },     // ج medial
  { dari: 'گنج', english: 'Treasure' },    // ج final
  { dari: 'پوچ', english: 'Hollow' },      // چ isolated
  { dari: 'بچه', english: 'Child' },       // چ medial
  { dari: 'هیچ', english: 'Nothing' },     // چ final, ه initial
  { dari: 'نفوذ', english: 'Influence' },  // ذ isolated, ف medial
  { dari: 'مغز', english: 'Brain' },       // ز final, غ medial
  { dari: 'نفس', english: 'Breath' },      // س final
  { dari: 'خلاص', english: 'Finished' },   // ص isolated
  { dari: 'نصف', english: 'Half' },        // ص medial, ف final
  { dari: 'شخص', english: 'Person' },      // ص final
  { dari: 'ضرر', english: 'Harm' },        // ض initial
  { dari: 'حضور', english: 'Presence' },   // ض medial
  { dari: 'عوض', english: 'Exchange' },    // ض isolated
  { dari: 'شرط', english: 'Condition' },   // ط isolated
  { dari: 'خطر', english: 'Danger' },      // ط medial
  { dari: 'خط', english: 'Line' },         // ط final
  { dari: 'لحاظ', english: 'Regard' },     // ظ isolated
  { dari: 'نظر', english: 'Opinion' },     // ظ medial
  { dari: 'حفظ', english: 'Memorize' },    // ظ final
  { dari: 'نوع', english: 'Type' },        // ع isolated
  { dari: 'بعد', english: 'After' },       // ع medial
  { dari: 'شمع', english: 'Candle' },      // ع final, م medial
  { dari: 'تیغ', english: 'Blade' },       // غ final
  { dari: 'برق', english: 'Electricity' },// ق isolated
  { dari: 'خاک', english: 'Soil' },        // ک isolated
  { dari: 'نمک', english: 'Salt' },        // ک final
  { dari: 'بزرگ', english: 'Big' },        // گ isolated
  { dari: 'سنگ', english: 'Stone' },       // گ final
  { dari: 'چشم', english: 'Eye' }          // م final
];
